import { atom } from "recoil";

export const withdrawalStore = atom({
	key: "withdrawalStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentSearch: "",
		selectedItems: [],
		sorting: {
			sortingColumn: {
				sortingField: "",
			},
			sortingDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
		},
		lastChecked: 0,
	},
});
